<script>
	import Layout from "../../layouts/main";
	import PageHeader from "../../components/page-header";
	import DateRangePicker from "vue2-daterange-picker";
	import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
	import pagination from "laravel-vue-pagination";
	import config from "../../config";
	import {date_ranges, get_currency} from "../../Helper/helper";
	import {driverService, reportService, commonService} from "../../services";

	export default 
	{
  		components: { Layout, PageHeader, DateRangePicker, pagination },
		data() 
		{
			let startDate = this.moment().startOf("day").toDate();
			let endDate = this.moment().endOf("day").toDate();
			
			return {
				date_ranges: date_ranges,
				dateRange: { startDate, endDate },
				deliveryIncentiveSumaryFields: [
					{ key: "restaurant_name", label: "Outlet Name"},
					{ key: "city_name", label: "City", sortable: true },
					{ key: "driver_name", label: "Fleet Name", sortable: true },
					{ key: "driverid", label: "Fleet Code", sortable: true },
					{ key: "total_orders", label: "Total Order", sortable: true },
					{ key: "total_amount", label: "Total Amount", sortable: true }
				],
				deliveryIncentiveSumaryData: [],
				loading: true,
				driverIncentivesTransactionsFields: [
					{ key: "created_at", label: "Date Stamp", sortable: true },
					{ key: "restaurant_name", label: "Outlet Name" },
					{ key: "city_name", label: "City", sortable: true },
					{ key: "driver_name", label: "Fleet Name", sortable: true },
					{ key: "driverid", label: "Fleet Code", sortable: true },
					{ key: "id", label: "Order Number", sortable: true },
					{ key: "order_source", label: "Order From", sortable: true },
					{ key: "scheduled_order", label: "Scheduled Order", sortable: true },
					{ key: "order_amount", label: "Order Amount", sortable: true },
					{ key: "distance_km", label: "KM Distance", sortable: false },
					{ key: "total_preptime_min", label: "Total Preptime Min", sortable: false },
					{ key: "total_delivery_time_min", label: "Total Delivery Time Min", sortable: false },
					{ key: "total_food_delivered_time", label: "Total Food Delivered Time", sortable: false },
					{ key: "delayed_or_early_time", label: "Delayed / Early Delivered Min", sortable: false },
					{ key: "base_incentives", label: "Base Incentives", sortable: false },
					{ key: "extra_incentives", label: "Extra/Festival Incentives", sortable: false },
					{ key: "driver_incentive", label: "Driver Incentive", sortable: false },
					{ key: "driver_penalty", label: "Driver Penalty", sortable: false },
					{ key: "net_incentives", label: "Net Incentives", sortable: false },
					{ key: "remarks", label: "Remarks" }
				],
				driverIncentivesTransactionsData: [],
				currency : get_currency(),
				limit: 2,
				perPage: 0,
				currentPage: 1,
				paginations: {},
				paginationsIncentives: {},
				filters: {
					start_date: this.moment().format('YYYY-MM-DD'),
					end_date: this.moment().format('YYYY-MM-DD'),
				},
				sortBy: "created_at",
				loading: true,
				loadingData: true,
				exporting: false,
				config:config,
			};
		},
		mounted() {
			this.getDeliveryIncentiveSummary();
			this.getDriversIncentives();
		},
		methods: {
			getDeliveryIncentiveSummary(page) 
			{
				this.loading = true;
				driverService.getDeliveryIncentiveSummary({ 
					...this.filters,
					sortBy: this.sortBy,
					orderBy: this.sortDesc ? "desc" : "asc",
					page: page 
				}).then(response => {
					var response = response?.data?.result;
					this.deliveryIncentiveSumaryData = response?.data;
					this.paginations = response;
					this.loading = false;
				})	
			},
			getDriversIncentives(page) 
			{
				this.loadingData = true;
				driverService.getDriversIncentives({ 
					...this.filters,
					vendor_id: this.$auth.getVendorId(),
					sortBy: this.sortBy,
					orderBy: this.sortDesc ? "desc" : "asc",
					page: page 
				}).then(response => {
					var response = response?.data?.result;
					this.driverIncentivesTransactionsData = response?.data;
					this.loadingData = false;
					this.paginationsIncentives = response;
				})	
			},
			btoa(str) {
				return btoa(str);
			},
			searchByDateRange(date) {
				this.filters = {
					...this.filters,
					start_date: this.moment(date.startDate.toISOString()).format('YYYY-MM-DD'),
					end_date: this.moment(date.endDate.toISOString()).format('YYYY-MM-DD'),
				}

				this.getDeliveryIncentiveSummary();
				this.getDriversIncentives();
			},
			sortingChanged(ctx) {
				this.sortBy = ctx.sortBy;
				this.sortDesc = ctx.sortDesc;
				this.getDriversIncentives();
			},
			sortingSummaryChanged(ctx) {
				this.sortBy = ctx.sortBy;
				this.sortDesc = ctx.sortDesc;
				this.getDeliveryIncentiveSummary();
			},
			async downloadsCSV(type) 
			{
				console.log(type, type != "");
				if(type !== "")
				{
					try {
						const token = localStorage.getItem("token"); // Get auth token
						if (!token) {
							console.error("No authentication token found");
							return;
						}

						// Construct query parameters
						// const params = new URLSearchParams({
						// 	...this.filters,
						// 	sortBy: this.sortBy,
						// 	orderBy: this.sortDesc ? "desc" : "asc",
						// 	vendor_id: this.$auth.getVendorId(),
						// 	type: type,
						// 	token: token
						// });

						// const jsonString = '';
						const encryptedData = commonService.encryptRequest({
							...this.filters,
							sortBy: this.sortBy,
							orderBy: this.sortDesc ? "desc" : "asc",
							vendor_id: this.$auth.getVendorId(),
							type: type
						});
						console.log('encryptedData', encryptedData);
						const apiUrl = `${config.api_url}driver-incentive-report?encd=${encodeURIComponent(encryptedData)}`;

						console.log(apiUrl, config.api_url);
						
						window.open(apiUrl, '_blank');
						
						// // Fetch the CSV file with authentication
						// const response = await fetch(apiUrl, {
						// 	method: "GET",
						// 	headers: {
						// 		"Authorization": `Bearer ${token}`,
						// 		"Accept": "text/csv",
						// 	}
						// });

						// if (!response.ok) throw new Error(`Failed to download: ${response.statusText}`);

						// // Extract filename from Content-Disposition header
						// // const contentDisposition = response.headers.get("Content-Disposition");
						// let filename = "Driver_Incentive_Report.csv"; // Default filename

						// 	const contentDisposition = response.headers.get("Content-Disposition");
						// 	if (contentDisposition) {
						// 		const match = contentDisposition.match(/filename="?([^"]+)"?/);
						// 		if (match) {
						// 			filename = match[1]; // Extract filename
						// 		}
						// 	}

						// // 🔥 Fix: Replace commas and extra spaces with underscores
						// // filename = filename.replace(/[, ]/g, "_");

						// // Convert response to Blob and trigger download
						// const blob = await response.blob();
						// const url = window.URL.createObjectURL(blob);
						// const link = document.createElement("a");
						// link.href = url;
						// link.setAttribute("download", filename);
						// document.body.appendChild(link);
						// link.click();
						// document.body.removeChild(link);
						// window.URL.revokeObjectURL(url);

						
					} catch (error) {
						console.error("Download failed", error);
					}
				}
			},
			
		},
		filters: {
			date(val) {
				return val ? val.toLocaleString() : "";
			},
		},
	
		
	};
</script>

<template>
	<Layout>
		<div>
			<div class="row">
				<div class="col-12">
					<div class="page-title-box d-flex align-items-center justify-content-between icon-main-page">
						<div class="page-title-left avatar-main-icon">
							<div class="avatar-xs mr-3">
								<span class="avatar-title rounded-circle bg-soft-primary text-primary font-size-18">
									<i class="bx bx-purchase-tag"></i>
								</span>
							</div>
							<div class="report-tag" v-if="!$auth.partner_login">
								<h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Driver Incentives Report') }}</h4>
								<p><router-link :to="{ name: 'reports-list'}">{{ trans.get('__JSON__.Reports') }}</router-link> > {{ trans.get('__JSON__.Driver Incentives Report') }}</p>
							</div>
							<div class="report-tag" v-else>
								<h4 class="mb-0 font-size-18">{{ trans.get('__JSON__.Driver Incentives Report') }}</h4>
								<p><router-link :to="{ name: 'vendor.reports.list'}">{{ trans.get('__JSON__.Reports') }}</router-link> > {{ trans.get('__JSON__.Driver Incentives Report') }}</p>
							</div>
						</div>
						<div class="justify-content-end mb-3 row">
							<div class="">
								<label for="">{{trans.get('__JSON__.Date')}}</label>
								<div class="text-sm-right">
									<div class="mr-2 ">
									<date-range-picker
										ref="picker"
										:locale-data="{
										firstDay: 1,
										format: 'dd-mm-yyyy',
										}"
										:showDropdowns="true"
										:showWeekNumbers="true"
										opens="left"
										v-model="dateRange"
										:ranges="date_ranges()"
										@update="searchByDateRange"
									>
										<template
											v-slot:input="picker"
											style="min-width: 350px"
										>
										{{ moment(picker.startDate.toISOString()).format('YYYY-MM-DD') | date }} -
										{{ moment(picker.endDate.toISOString()).format('YYYY-MM-DD') | date }}
										</template>
									</date-range-picker>
									</div>
								</div>
							</div>
						</div>
					</div>              
				</div>
			</div>
			<div class="row">
				<div class="col-12 list-table-main driver-incentive-report">
					<div class="card">
						<div class="card-body">

							<!-- First Summary Table Starts -->
							 <div class="row mb-2">
								<div class="col-md-6">
									<h5>{{ trans.get('__JSON__.Summary - each delivery incentives') }}</h5>
								</div>
								<div class="col-md-6" v-if="!loading">
									<button @click="downloadsCSV(1)" 
										v-if="$auth.hasSubAdminPermission(config.permissions.reports_export)"
										class="btn btn-primary btn-rounded float-right" :disabled="exporting">
										{{trans.get(!exporting?'__JSON__.Export To CSV':'__JSON__.Exporting')}}
										</button>
								</div>
							 </div>
							
							<div class="row table-responsive border-0">
								<div class="col-12 table-main-list table table-centered table-nowrap">
									<!-- :sort-by.sync="sortBy" -->
									<b-table 
									:sort-by.sync="sortBy"
									:no-local-sorting="true"
									@sort-changed="sortingSummaryChanged"
									show-empty
									:items="deliveryIncentiveSumaryData" 
									:fields="deliveryIncentiveSumaryFields"
									:busy="loading"
									>
									
									<template #table-busy>
										<div class="text-center text-danger my-2">
											<b-spinner class="align-middle"></b-spinner>
											<strong>{{trans.get('__JSON__.Loading...')}}</strong>
										</div>
									</template>
									<template v-slot:cell(total_amount)="data">
										<span v-html="currency"></span>
										{{data.item.total_amount.toFixed(2) || '0.00' }}
									</template>

									</b-table>
									<div class="row col-sm-5 offset-sm-7">
										<div class="col">
											<div class="dataTables_paginate paging_simple_numbers float-right">
												<ul class="pagination pagination-rounded mb-0">
													<pagination
													:data="paginations"
													:limit="limit"
													@pagination-change-page="getDeliveryIncentiveSummary"
													></pagination>
												</ul>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- First Summary Table End -->

							<!-- Incentive Detail Transaction Starts  -->
									<div class="row mt-2">
										<div class="col-12">
											<div class="row mb-2">
										<div class="col-md-6">
											<h5>{{ trans.get('__JSON__.Detail Transactions') }}</h5>
										</div>
										<div class="col-md-6" v-if="!loadingData">
											<button @click="downloadsCSV(2)" 
												v-if="$auth.hasSubAdminPermission(config.permissions.reports_export)"
												class="btn btn-primary btn-rounded float-right" :disabled="exporting">
												{{trans.get(!exporting?'__JSON__.Export To CSV':'__JSON__.Exporting')}}
												</button>
										</div>
									</div>
									
									<div class="row table-responsive">
										<div class="col-12 table-main-list table table-centered table-nowrap">
											<b-table 
											:sort-by.sync="sortBy"
											:no-local-sorting="true"
                    						@sort-changed="sortingChanged"
											show-empty
											:items="driverIncentivesTransactionsData" 
											:fields="driverIncentivesTransactionsFields"
											:busy="loadingData"
											>
												<template #table-busy>
													<div class="text-center text-danger my-2">
														<b-spinner class="align-middle"></b-spinner>
														<strong>{{trans.get('__JSON__.Loading...')}}</strong>
													</div>
												</template>
												<template v-slot:cell(restaurant_name)="data">
													<b-link :to="{name: 'vendor-detail', params: {restaurant_id: btoa((data && data.item && data.item.restaurant_id) || 0),},}">
														{{ data.item.restaurant_name }}
													</b-link>
												</template>
												<template v-slot:cell(driver_name)="data">
													<b-link :to="{name: 'driver-details', params: {driver_id: btoa((data && data.item && data.item.driver_id) || 0),},}">
														{{ data.item.driver_name }}
													</b-link>
												</template>
												<template v-slot:cell(order_source)="data">
													<div>{{ data.value || "Chowman" }}</div>
												</template>
												<template v-slot:cell(id)="data">
													{{  data.item.id ? "#" + data.item.id : '' }}
												</template>

												<template v-slot:cell(order_amount)="data">
													<span v-html="currency"></span>
													{{ data.item.order_amount.toFixed(2) || '0.00' }}
												</template>

												<template v-slot:cell(base_incentives)="data">
													<span v-html="currency"></span>
													{{ data.item.base_incentives.toFixed(2) || '0.00' }}
												</template>

												<template v-slot:cell(driver_penalty)="data">
													<span v-html="currency"></span>
													{{ data.item.driver_penalty.toFixed(2) || '0.00' }}
												</template>

												<template v-slot:cell(driver_incentive)="data">
													<span v-html="currency"></span>
													{{ data.item.driver_incentive.toFixed(2) || '0.00' }}
												</template>

												<template v-slot:cell(net_incentives)="data">
													<span v-html="currency"></span>
													{{ data.item.net_incentives.toFixed(2) || '0.00' }}
												</template>
											</b-table>
										</div>
										<div class="row col-sm-5 offset-sm-7">
											<div class="col">
												<div class="dataTables_paginate paging_simple_numbers float-right">
													<ul class="pagination pagination-rounded mb-0">
														<pagination
														:data="paginationsIncentives"
														:limit="limit"
														@pagination-change-page="getDriversIncentives"
														></pagination>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<!-- Incentive Detail Transaction End  -->

						</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>

<style>
.driver-incentive-report table{
	margin-top: 0 !important;
}
</style>